import React from "react";
import Top from "../../Top";
import Left from "../../Left";
import { Grid } from "@mui/material";
import SortIcon from "@mui/icons-material/Sort";
import SearchIcon from "@mui/icons-material/Search";
// import MicIcon from "@mui/icons-material/Mic";
import MarkunreadIcon from "@mui/icons-material/Markunread";

import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { useEffect } from "react";
import { makePostRequest } from "../../../utils/utils";
import swal from "sweetalert";
import ProgressBar from "./ProgressBar";
import Tooltip from "@mui/material/Tooltip";

import "react-circular-progressbar/dist/styles.css";
import ToggleButton from "@mui/material/ToggleButton";
import ImportExportIcon from "@mui/icons-material/ImportExport";
import Pagination from "@mui/material/Pagination";
// import Stack from "@mui/material/Stack";

import moment from "moment";
// import dayjs from "dayjs";
import Zoom from "react-medium-image-zoom";

function VisitorsManagement2() {
  const [selected, setSelected] = React.useState(false);

  // For memu
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const [visitorList, setVisitorsList] = React.useState([]);
  const [q, setQ] = React.useState("");
  const [status, setStatus] = React.useState("All");
  // const [timeArr, setTimeArr] = React.useState([]);
  // const [lstNotification, setLstNotification] = React.useState([]);

  const [sortBy, setSortBy] = React.useState("");
  const [Upload, setUpload] = React.useState(false);

  //pagination
  const [currentPage, setCurrentPage] = React.useState(1);
  const [itemsPerPage] = React.useState(5);
  const [totalItems, setTotalItems] = React.useState(0);

  const [dumypicture] = React.useState(
    require("../../../assets/Images/avtarPic.png")
  );

  const handlePageChange = (e, page) => {
    setCurrentPage(page);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = (e) => {
    setAnchorEl(null);
    let st = e.currentTarget.dataset.myValue || "all";;
    setStatus(st);
    getAllVisitors(st);
    //window.location.reload()
  };

  async function handleChangeSortBy() {
    if (sortBy === "")
      setSortBy("ASC")
    else if (sortBy === "DESC")
      setSortBy("ASC")
    else if (sortBy === "ASC")
      setSortBy("DESC")
    setUpload(!Upload);
    getAllVisitors(status);
  }

  // End

  useEffect(() => {
    getAllVisitors(status);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [q, Upload, currentPage]);

  React.useEffect(() => {
    if (q) {
      setCurrentPage(1);
    }
  }, [q]);

  // async function sendNotification(fcm_token) { }

  async function getAllVisitors(st) {
    let bodyFormData = {
      searchq: q,
      pageNo: currentPage,
      count: itemsPerPage,
      status: st,
      sortBy: sortBy
    };

    makePostRequest("visitor/visitorlisting", bodyFormData)
      .then((response) => {
        if (response.status === 201) {
          const data = response.data.data.data;
          setVisitorsList(data);
          setTotalItems(response.data.data.total_records);
        } else {
          swal("There was an error!", response.message, "warning");
        }
      })
      .catch((err) => {
        swal("There was an error!", "more error details", "warning");
      });
  }

  function toHoursAndMinutes(totalMinutes) {
    const hours = Math.floor(totalMinutes / 60).toLocaleString("en-US", {
      minimumIntegerDigits: 2,
      useGrouping: false,
    });

    const minutes = (totalMinutes % 60).toLocaleString("en-US", {
      minimumIntegerDigits: 2,
      useGrouping: false,
    });

    var str = hours + ":" + minutes;
    return str;
  }

  //Converts time from 24 to 12 hour format
  // function timeConvert(time) {
  //   // Check correct time format and split into components
  //   if (time) {
  //     time = time
  //       .toString()
  //       .match(/^([01]\d|2[0-3])(:)([0-5]\d)(:[0-5]\d)?$/) || [time];

  //     if (time.length > 1) {
  //       // If time format correct
  //       time = time.slice(1); // Remove full string match value
  //       time[5] = +time[0] < 12 ? "AM" : "PM"; // Set AM/PM
  //       time[0] = +time[0] % 12 || 12; // Adjust hours
  //     }
  //     return time.join(""); // return adjusted time or original string
  //   } else return "";
  // }

  // const percentage = 30;

  // const [anchorEl2, setAnchorEl2] = React.useState(null);

  // const handleClick2 = (event) => {
  //   setAnchorEl2(event.currentTarget);
  // };

  return (
    <>
      <Top />
      <Left />
      <div className="rightContent">
        <Grid container spacing={3} className="mainHeadingLine">
          <Grid item xs={12} md={12} className="oneLineBt">
            <h1 className="panelHeading">Visitor Management</h1>
          </Grid>
          <Grid item xs={12} md={12}>
            <div className="residentManagementTable">
              <div className="visitorListNewOut">
                <div className="visitorHead">Visitor List</div>
                <div className="visitorListNewInner">
                  <div className="visitorSearch">
                    <div className="visitorSearchDiv">
                      <SearchIcon className="visitorSearchIco" />
                      <input
                        type="text"
                        placeholder="Search"
                        onChangeCapture={(e) => setQ(e.target.value)}
                      />
                      {/* <MicIcon className="visitorMicIco" /> */}
                    </div>
                    <div>
                      <SortIcon
                        className="visitorFilterIco"
                        aria-controls={open ? "basic-menu" : undefined}
                        aria-haspopup="true"
                        aria-expanded={open ? "true" : undefined}
                        onClick={handleClick}
                      />
                      <Menu
                        id="basic-menu"
                        anchorEl={anchorEl}
                        open={open}
                        onClose={handleClose}
                        MenuListProps={{
                          "aria-labelledby": "basic-button",
                        }}
                      >
                        <MenuItem
                          data-my-value={"all"}
                          onClick={handleClose}
                        >
                          All
                        </MenuItem>
                        <MenuItem
                          data-my-value={"approved"}
                          onClick={handleClose}
                        >
                          Approved
                        </MenuItem>
                        <MenuItem
                          data-my-value={"pending"}
                          onClick={handleClose}
                        >
                          Pending
                        </MenuItem>
                        <MenuItem
                          data-my-value={"rejected"}
                          onClick={handleClose}
                        >
                          Rejected
                        </MenuItem>
                        <MenuItem
                          data-my-value={"active"}
                          onClick={handleClose}
                        >
                          Active
                        </MenuItem>
                        <MenuItem
                          data-my-value={"preapproved"}
                          onClick={handleClose}
                        >
                          PreApproved
                        </MenuItem>
                      </Menu>
                    </div>
                    <div className="sortingIcoOut">
                      {/* Statics */}

                      <ToggleButton
                        value="check"
                        selected={selected}
                        onChange={() => {
                          setSelected(!selected);
                        }}
                      >
                        <Tooltip
                          title="Sort by A-Z and Z-A"
                          placement="bottom"
                          arrow
                        >
                          <ImportExportIcon
                            className="visitorFilterIco"
                            aria-controls={open}
                            aria-haspopup="true"
                            aria-expanded={open}
                            onClick={handleChangeSortBy}
                          />
                        </Tooltip>

                      </ToggleButton>

                    </div>
                  </div>

                  {visitorList.map((option) => (
                    <div
                      className="visitContDiv textTagDivOuter forReject"
                      key={option.visitor_id}
                    >
                      <div className="textTagDiv">{option.status}</div>

                      {option.status === "rejected" ? (
                        <>
                          <span className="rejectStatus">
                            {option.status_message}
                          </span>
                          <label className="rejectedLabSt">Rejected</label>
                        </>
                      ) : (
                        <></>
                      )}
                      <div className="visitCont1">
                        {option.driver_pic == null ||
                          option.driver_pic === "" ? (
                            
                          <div className="visitContProf">
                            <Zoom>
                            <img src={dumypicture} alt="altimg"/>
                            </Zoom>
                          </div>
                        ) : (
                          
                          <div className="visitContProf">
                            <Zoom>
                            <img src={option.driver_pic} alt="altimg"/>
                            </Zoom>
                          </div>
                        )}
                        <div className="visitContLeft">
                          <h3 className="visitContHed">
                            {option.user_obj.first_name}{" "}
                            {option.user_obj.last_name}
                            <span>({option.guest_type})</span>
                            {/* <span>Visiting to</span>
                          <b>Wing A- 922</b> */}
                          </h3>
                          <p className="visitContMob">
                            {option.user_obj.contact_no}
                          </p>
                          <p className="visitContTime forImailAlig">
                            <MarkunreadIcon className="forEmailAndPhone" />
                            {option.user_obj.email_id ?
                              <>{option.user_obj.email_id}</>
                              :
                              <>-</>
                            }
                          </p>
                          <p className="visitContTime">
                            approved for
                            <b>
                              {toHoursAndMinutes(option.tot_stay_time)} Hours
                            </b>
                            <span className="plusIcoForTime">+</span>
                            <b style={{ color: "green" }}>00:00 Hours</b>
                          </p>
                        </div>

                        <div className="visitContRight">
                          {/* <div id="progress-circle" >
                          <div id="inner-circle" >66</div>
                          <div id="static-circle"></div>
                          <div id="dynamic-wrapper" value={66}>
                            <div id="dynamic-circle"></div>
                          </div>
                        </div> */}
                          {/* {!lstNotification?
                            <div className="visitorNotiMain">
                              <Tooltip title="Notification">
                              <Badge
                              badgeContent={localStorage.getItem('lstJsonNotiObj').length}
                              color="primary"
                              onClick={handleClick2}>
                                <IconButton>
                                  <NotificationsIcon />
                                </IconButton>
                                </Badge>
                              </Tooltip>
                            </div>
                          :<div>{lstNotification.length}</div>} */}
                          {option.status === "pending" ||
                            option.status === "active" ? (
                            <div className="progressBarDiv">
                              {/* <CircularProgressbar value={calculateTimeDifference(option.entry_time,option.exit_time)} maxValue={option.tot_stay_time} text={`${100}`} /> */}
                              <ProgressBar
                                hrs={option.tot_stay_time}
                                entryTime={option.entry_time}
                                exitTime={option.exit_time}
                                approvalTime={option.approval_time}
                                flag={option.status}
                                fcm_token={option.fcm_token}
                                id={option.visitor_id}
                                fname={option.user_obj.first_name}
                                lname={option.user_obj.last_name}
                                profile_pic={option.driver_pic}
                                guest_type={option.guest_type}
                              />
                            </div>
                          ) : (
                            <div></div>
                          )}
                        </div>
                      </div>
                      <div className="visitCont2">
                        <div className="visitBottCont">
                          {option.status === "rejected" ? (
                            <p className="rejectStatus">Rejected By</p>
                          ) : (
                            <p>To Be Approved By</p>
                          )}
                          <b>
                            {option.resident_fname} {option.resident_lname}
                          </b>
                        </div>
                        <div className="visitBottCont">
                          {option.status === "rejected" ? (
                            <p className="rejectStatus">Rejection Time</p>
                          ) : (
                            <p>Approval Time</p>
                          )}

                          {option.approval_time ? (
                            // <b>{dayjs(option.approval_time).format('YYYY-MM-DD hh:mm a')}</b>
                            <b>
                              {/* {moment
                                .utc(option.approval_time)
                                .format("DD-MM-YYYY HH:MM")} */}
                              {moment
                                .utc(option.approval_time)
                                .format("DD-MM-YYYY hh:mm A")}
                            </b>
                          ) : (
                            <></>
                          )}
                        </div>
                        <div className="visitBottCont">
                          <p>Arrival Time</p>
                          {option.status !== "rejected" ? (
                            <>
                              {option.entry_time ? (
                                <b>
                                  {moment
                                    .utc(option.entry_time)
                                    .format("DD-MM-YYYY hh:mm A")}
                                  {/* {option.entry_time.split("T")[0]}
                              {timeConvert(
                                option.entry_time
                                  .split("T")[1]
                                  .slice(
                                    0,
                                    option.entry_time.split("T")[1].length - 1
                                  )
                              )} */}
                                </b>
                              ) : (
                                <center>-</center>
                              )}
                            </>
                          ) : (
                            <center>-</center>
                          )}
                        </div>

                        <div className="visitBottCont">
                          <p>Exit Time</p>
                          {option.status !== "rejected" && option.status !== 'Collected' ? (
                            <>
                              {option.exit_time ? (
                                <b>
                                  {moment
                                    .utc(option.exit_time)
                                    .format("DD-MM-YYYY hh:mm A ")}

                                  {/*moment(option.exit_time).format(
                                    "DD-MM-YYYY hh:mm A"
                                  )*/}
                                </b>
                              ) : (
                                <center>-</center>
                              )}
                            </>
                          ) : (
                            <center>-</center>
                          )}
                        </div>
                      </div>
                    </div>
                  ))}

                  <Grid container spacing={3} >
                    <Grid item xs={12} md={12} >
                      <Pagination count={Math.ceil(totalItems / itemsPerPage)}
                        page={currentPage}
                        onChange={handlePageChange}
                        variant="outlined"
                        shape="rounded" />
                    </Grid>
                  </Grid>
                  {/* <div className="listPaginationMain">
                    <Stack spacing={2}>
                      <Pagination
                        count={10}
                        variant="outlined"
                        shape="rounded"
                      />
                    </Stack>
                  </div> */}
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  );
}

export default VisitorsManagement2;
